import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';

export const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 40px;
  min-width: 60px;
  max-width: 96px;
  background-color: ${COLORS.GROUND_UNDERGROUND};
  border-radius: 4px;
  padding: 0 4px;
  font-size: 11px;
  font-weight: 500;
  text-transform: capitalize;
`;
